module.exports = __webpack_public_path__ + "img/Transaction-fee-icon@2x.0f33df21.svg";